export const SECTION_ID = 'jira.board';
